import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  Typography,
  Box,
} from "@mui/material";
import UserApi from "../api/UserApi";

const AddUserDialog = ({ open, onClose, onUserAdded }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState(0); // Default to 'User'
  const [error, setError] = useState(""); // Validation error state

  const allowedDomains = ["frame.shrood.net", "framebrand.onmicrosoft.com"];

  const handleSubmit = async () => {
    if (!name || !email) {
      setError("Name and email are required.");
      return;
    }

    const emailDomain = email.split("@")[1];
    if (!allowedDomains.includes(emailDomain)) {
      setError("Invalid Email ID.");
      return;
    }

    try {
      const newUser = await UserApi.addUser({ name, email, role });
      onUserAdded(newUser.data); // Notify parent of the new user
      handleClose(); // Reset and close the dialog
    } catch (err) {
      console.error("Error adding user:", err);
      setError("Failed to add user. Please try again.");
    }
  };

  const handleClose = () => {
    setName("");
    setEmail("");
    setRole(0); // Reset form
    setError("");
    onClose(); // Close the dialog
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Add New User</DialogTitle>
      <DialogContent>
        <TextField
          label="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          margin="normal"
          error={!name && error.includes("Name")}
        />
        <TextField
          label="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          fullWidth
          margin="normal"
          type="email"
          error={
            (!email && error.includes("email")) ||
            (email && error.includes("Invalid Email"))
          }
        />
        <TextField
          label="Role"
          value={role}
          onChange={(e) => setRole(e.target.value)}
          select
          fullWidth
          margin="normal"
        >
          <MenuItem value={0}>User</MenuItem>
          <MenuItem value={1}>Admin</MenuItem>
        </TextField>
        {/* Show overall error message above buttons */}
        {error && (
          <Box sx={{ mt: 2, mb: 2 }}>
            <Typography
              variant="body2"
              color="error"
              align="center"
              sx={{ fontSize: "0.9rem" }}
            >
              {error}
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary" variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          disabled={!name || !email} // Disable button if inputs are empty
        >
          Add User
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddUserDialog;
